<template>
  <a
    href="javascript:;"
    class="play-back"
    v-show="show"
    @click="handleClick($event)"
  >
    <i class="icon icon-playback"></i>
    {{ $t('button_common_playback') }}
  </a>
</template>

<script>
export default {
  name: 'ButtonPlayBack',
  props: {
    show: {
      type: [Boolean, Number, String],
      default: true,
    },
  },
  methods: {
    handleClick(event) {
      this.$emit('click', event)
    },
  },
}
</script>

<style lang="scss" scoped>
.play-back {
  font-size: 14px;
  color: #FAAE56 !important;

  .icon {
    display: inline-block;
    width: 14px;
    height: 14px;
    vertical-align: -2px;
    margin-right: 4px;
  }
}
</style>
